// extracted by mini-css-extract-plugin
module.exports = {"list":"Backup_list__LGku6","wrapper":"Backup_wrapper__4kFqQ","button":"Backup_button__2P0h7"};